import { Button } from '@material-ui/core';
import React from 'react';
import { IKeypadButtonProps } from '../../interfaces/IKeypadButtonProps';
import { keypadButtonStyles } from './keypad-button-styles';

const KeypadButton: React.FC<IKeypadButtonProps> = (
  props: React.PropsWithChildren<IKeypadButtonProps>,
): JSX.Element => {
  const classes = keypadButtonStyles();

  const cssClass = props.className
    ? `${classes.keypadButton} ${props.className} fullWidth`
    : `${classes.keypadButton} fullWidth`;

  return (
    <Button
      color='primary'
      variant='contained'
      className={cssClass}
      onClick={props.onClick}
      centerRipple={true}
      data-testid={props.dataTestId}
      disabled={props.disableButton}
    >
      {props.children}
    </Button>
  );
};

export default KeypadButton;
